import { render, staticRenderFns } from "./DetailSubmission.vue?vue&type=template&id=6cd631ae&"
import script from "./DetailSubmission.vue?vue&type=script&lang=js&"
export * from "./DetailSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports